import {
  Conversation,
  ConversationLogItemParticipantLeft,
} from '@stripe-internal/conversations-client';
import {view} from '@sail/ui';
import {LeaveRow} from '../../Chat/Row/LeaveRow';
import {MetaRow} from '../../Chat/Row/MetaRow';

type Props = {
  conversation: Conversation;
  item: ConversationLogItemParticipantLeft;
  MetaRowComponent?: typeof MetaRow;
};

export const ParticipantLeftRow = ({
  conversation,
  item,
  MetaRowComponent = MetaRow,
}: Props) => {
  if (item.participant.id === conversation.user.id) {
    return null;
  }

  return (
    <view.div
      className="uh-conversations-contains-meta-row"
      data-testid="conversation-log-participant-left"
    >
      <LeaveRow
        name={item.participant.displayName}
        MetaRowComponent={MetaRowComponent}
      />
    </view.div>
  );
};
